export const radii = {
  none: { value: "0" },
  xs: { value: "0.212rem" }, // 3.4px
  sm: { value: "0.25rem" }, // 4px
  md: { value: "0.313rem" }, // 5px
  lg: { value: "0.375rem" }, // 6px
  xl: { value: "0.5rem" }, // 8px
  "2xl": { value: "0.625rem" }, // 10px
  "3xl": { value: "0.938rem" }, // 15px
  "4xl": { value: "1.25rem" }, // 20px
  "5xl": { value: "1.875rem" }, // 30px
};
